import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Paper, Typography, styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { FORM_NAME } from 'employee/Employee/common';
import { usePermission } from 'permissions/hooks';

const StyledPaper = styled(Paper)(({ theme: { palette, shadows, spacing } }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: palette.background.dark,
    boxShadow: shadows[0],
    paddingBottom: spacing(2)
}));

const SuccessMessage = styled(Typography)(({ theme: { spacing, typography, palette } }) => ({
    marginTop: spacing(5.5),
    fontWeight: typography.fontWeightBold,
    fontSize: '3vw',
    color: palette.text.primary,
    textAlign: 'center'
}));

/** Completion step shown after a change request is submitted from the reused
 *  wizard — mirrors the employee Complete step but returns to the profile. */
const ChangeRequestComplete = reduxForm({ form: FORM_NAME, destroyOnUnmount: false })(() => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('id');
    // Privileged users apply directly; everyone else submits a request.
    const canDirect = usePermission('profile-change-request.update directly');

    useEffect(() => {
        const target = email
            ? `/my-profile?id=${email}&isSelf=true`
            : '/my-profile';
        setTimeout(() => navigate(target), 2000);
    }, []);

    return (
        <StyledPaper>
            <SuccessMessage variant='h2'>
                {canDirect ? 'Information updated!' : 'Change request submitted!'}
            </SuccessMessage>
            <Typography variant='subtitle1'>
                {canDirect
                    ? 'Your changes have been saved. Redirecting to the profile…'
                    : 'It’s now waiting for admin approval. Redirecting to your profile…'}
            </Typography>
            <CircularProgress color='success' size={20} />
        </StyledPaper>
    );
});

export default ChangeRequestComplete;
